
const projectsData = {
  data: [
    {
      desktop_image: './img/volkno-poster.png',
      mobile_image: '',
      case_study: 'pages/Volkno',
      type: 'Startup - Web App',
      title: 'Volkno',
      date: '2016',
      github_url: '',
      project_url: 'https://volkno.com/',
      background: 'Pronounced "Volcano" - Platform for focus testing media content with CMS and custom analytics from propietary machine learning',
      role: 'UI/UX Designer, Front End Developer',
      tech_stack: [ 'Node.js','MongoDB']
    },
    {
      desktop_image: './img/i-angry-poster.png',
      mobile_image: 'https://www.dropbox.com/s/713op6pgfna3p8m/iangry-ui.jpg?raw=1',
      case_study: 'pages/MobileReddit',
      type: 'mobile app',
      title: 'Mobile Reddit Client',
      date: '2016',
      github_url: 'https://github.com/vishalgaglani/ReactJs-RedditSwipe',
      project_url: 'https://github.com/vishalgaglani/ReactJs-RedditSwipe',
      background: 'React Native mobile application for viewing subreddit images in a swipe card format',
      role: 'Design + Development',
      tech_stack: ['React.js', 'Redux' ]
    },
     {
      desktop_image: './img/macbook-portfolio.png',
      mobile_image: '',
      title: 'Portfolio',
      type: 'web app',
      case_study: 'pages/Portfolio',
      date: '2016',
      github_url: 'https://github.com/vishalgaglani/Traffic-Clock',
      project_url: '',
      background: 'Portfolio Built with ReactJS/Redux',
      role: 'Full-Stack Dev - UX',
      tech_stack: ['React.js', 'Redux']
    },
    {
      desktop_image: './img/cb-poster.png',
      mobile_image: '',
      case_study: 'pages/CreativeBoost',
      title: 'Anagram Puzzle Game',
      type: 'web app',
      date: '2016',
      github_url: 'https://github.com/vishalgaglani/creativeboost',
      project_url: 'https://github.com/vishalgaglani/creativeboost',
      background: 'Timed Anagram Puzzle Solving Game',
      role: 'Design + Development',
      tech_stack: ['AngularJS']
    },
 
    {
      desktop_image: './img/PartyBooking.jpg',
      mobile_image: '',
      title: 'Highly Relevant LLC',
      case_study: 'pages/HighlyRelevant',
      type: 'Wordpress CMS',
      date: '2016',
      github_url: '',
      project_url: '',
      background: 'Marketing Agency Specializing in Entertainment Companies',
      role: 'Full-Stack Dev - UX',
      tech_stack: []
    },
    
  ]
};

/*
  
    {
      desktop_image: 'https://www.dropbox.com/s/9bj1lbohfj7otwm/coffee.jpg?raw=1',
      mobile_image: '',
      title: 'Traffic Clock',
      case_study: 'pages/Traffic-Clock',
      type: 'web app',
      date: '2016',
      github_url: 'https://github.com/vishalgaglani/Traffic-Clock',
      project_url: '',
      background: 'Visual Clock Representation of Local Traffic Patterns',
      role: 'Full-Stack Dev - UX',
      tech_stack: ['React.js', 'Node.js', 'express', 'd3.js']
    },
{
      desktop_image: 'https://www.dropbox.com/s/1f58e2t7sxeke9x/tablet.jpg?raw=1',
      mobile_image: '',
      title: 'IMDB Trailers',
      type: 'tvOS app',
      case_study: 'pages/IMDB',
      date: '2016',
      github_url: 'https://github.com/vishalgaglani/Traffic-Clock',
      project_url: '',
      background: 'Single Page App for viewing latest IMDB Trailers',
      role: 'Full-Stack Dev - UX',
      tech_stack: ['React.js', 'Node.js', 'express']
    }

*/
export { projectsData };



/** WEBPACK FOOTER **
 ** ./src/data/projects.js
 **/